var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImporticon = function SvgImporticon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.36 10.5c-.14 0-.28-.07-.35-.14L3.44 6.72a.338.338 0 0 1 0-.49l.49-.49c.07-.14.35-.14.49.07L6.8 8.19V1.05c0-.21.14-.35.35-.35h.7c.21 0 .35.14.35.35v7.14l2.38-2.38c.14-.14.35-.14.49 0l.49.49c.14.14.14.35 0 .49l-3.57 3.57c-.07.07-.21.14-.35.14h-.28Zm6.44-1.05v2.45c0 .77-.63 1.4-1.4 1.4H2.6c-.77 0-1.4-.63-1.4-1.4V9.45c0-.21.14-.35.35-.35h.7c.21 0 .35.14.35.35v2.45h9.8V9.45c0-.21.14-.35.35-.35h.7c.21 0 .35.14.35.35Z",
    clipRule: "evenodd"
  })));
};
export default SvgImporticon;